// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-search-bar-___search-bar__search-bar___Vq0zu {
  border-bottom: 1px solid var(--default-border);
  margin-bottom: 0.5em;
  display: flex;
  font-size: 1.25em;
  line-height: 2.15;
}

.src-components-search-bar-___search-bar__search-bar-input___mzENC {
  border: none;
  padding: 0 15px;
  flex-grow: 2;
}
`, "",{"version":3,"sources":["webpack://./src/components/search-bar/search-bar.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd","sourcesContent":[".search-bar {\n  border-bottom: 1px solid var(--default-border);\n  margin-bottom: 0.5em;\n  display: flex;\n  font-size: 1.25em;\n  line-height: 2.15;\n}\n\n.search-bar-input {\n  border: none;\n  padding: 0 15px;\n  flex-grow: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-bar": `src-components-search-bar-___search-bar__search-bar___Vq0zu`,
	"searchBar": `src-components-search-bar-___search-bar__search-bar___Vq0zu`,
	"search-bar-input": `src-components-search-bar-___search-bar__search-bar-input___mzENC`,
	"searchBarInput": `src-components-search-bar-___search-bar__search-bar-input___mzENC`
};
export default ___CSS_LOADER_EXPORT___;
